import(/* webpackMode: "eager" */ "/vercel/path0/drift-common/common-ts/lib/clients/DlobWebsocketClient.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/node_modules/@dialectlabs/react-ui/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/ui/node_modules/@vercel/analytics/dist/react/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadResources"] */ "/vercel/path0/ui/src/app/preload-resources.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/AppWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/ui/src/components/Pwa/PwaRegistrar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/styles/index.css");
